const button = document.querySelector('.section_hero_button');
const targetSection = document.querySelector('.section_store_bundle');

// Add click event listener to the button
if (button && targetSection) {
    button.addEventListener('click', (event) => {
    event.preventDefault(); // Prevent default anchor behavior

        // Get the height of the sticky header (adjust selector if necessary)
      const stickyHeader = document.getElementById('shopify-section-header');
      const stickyToolbar = document.getElementById('shopify-section-toolbar');

       const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
       const toolbarHeight = stickyToolbar ? stickyToolbar.offsetHeight : 0;

        // Calculate total offset
        const totalOffset = headerHeight + toolbarHeight;

        // Calculate the top position with the combined offset
        const targetPosition = targetSection.getBoundingClientRect().top + window.scrollY - totalOffset;

        // Scroll to the calculated position smoothly
        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });
    });
} else {
    console.error('Button or target section not found.');
}


if (!customElements.get('bundle-form')) {
    class BundleForm extends HTMLElement{
        constructor(){
            super();
            this.page = this.getAttribute('data-page-title')
            this.form = this.querySelector('form')
        }

        connectedCallback(){
            this.form.addEventListener('submit',(event)=>{
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
                this.handleFormSubmission();
            })
        }

        async handleFormSubmission(){
            await BundleForm.cartClear().then(async()=>{
                await BundleForm.addToCart(this.form).then(async(cartRes)=>{
                    document.dispatchEvent(
                        new CustomEvent('ajaxProduct:added', {
                            bubbles: true,
                            detail: {
                                product: cartRes,
                                ddToCartBtn: this.querySelector(`#ProductSubmitButton-${this.dataset.sectionId}`)
                            }
                        })
                    )
                    setTimeout(() => {
                        document.querySelector("button[name='checkout']")?.click()
                    }, 500);
                    // fetch(`/checkout.json`).then(async(checkout_obj)=>{
                    //     window.location.href = `${checkout_obj.url}`
                    // });
                })
            })
        }

        static async cartClear(){
            const clearCartReq = await fetch('/cart/clear.js')
            const clearCartRes = await clearCartReq.json()
            return clearCartRes
        }

        static async addToCart(form){
            let count = form.querySelector('span.bundle-count').dataset.count
            let formObject = []
            for (let index = 1; index <= parseInt(count); index++) {
                let id = form.querySelector(`input[name="items[${index}][id]"]`).value
                let quantity = form.querySelector(`input[name="items[${index}][quantity]"]`).value
                let item = {
                    id: parseInt(id),
                    quantity: parseInt(quantity),
                    properties:{
                        "__source": __st.rid
                    }
                }
               formObject.push(item)
            }

            const cartReq = await fetch(`/cart/add.js`,{
                method: "POST",
                headers:{
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({items: formObject, sections:"cart-ajax"})
            });
            const cartRes = await cartReq.json()
            return cartRes
        }
    }
    customElements.define('bundle-form', BundleForm)
}
